import React, { useEffect, useMemo, useState } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';

import { ConsumableQuantityEstimationProps } from './consumable-quantity-estimation';
import help from './consumable-quantity-estimation.help';
import ExportConsumableColumns, { consumableEstimationType } from '../../types/consumableEstimationType';
import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData } from '../../services/posts/postdata';
import { apiUriConsumableDataHttp, apiUriMasterDataHttp } from '../../services/conf/apiConf';

function useConsumableQuantityEstimationHook(props: ConsumableQuantityEstimationProps) {
  useResourceBundle(translations, undefined, '52d86de1-7070-4e54-9d31-2cea047f606a');
  useHelpBundle(help);

  const { t } = useTranslation();
  const [columnNames, setColumnNames] = useState(ExportConsumableColumns());
  const [dataForColumns, setdataForColumns] = useState();
  const [productList, setProductList] = useState();
  const [inputValue, setInputValue] = useState(2);
  const [plannedYears, setPlannedYears] = useState(2);
  const [productType, setProducttype] = useState([]);
  const [productTypesList, setProductTypesList] = useState([]);
  const [productSize, setProductSize] = useState([]);
  const [prodDetail, setProdDetail] = useState([]);
  const [size, setSize] = useState();
  const [prodCode, setProdCode] = useState();
  const [makeJson, setMakeJson] = useState({});
  useEffect(() => {
    fetchAllDataGet_byApiName('GetMasterProductDetails', apiUriMasterDataHttp())
      .then((response) => {
        setProdDetail(response);
        const list = response?.map((item) => item.producttype);
     
       setProducttype(response[0].producttype);
        setProductTypesList(list);
        if (productType.length !== 0) {
          console.log(productType);
          // const sizeval = response?.map((item) => item.productdescription);
          const sizeval = response
            .filter((item) => item.producttype === productType)
            .map((item) => item.proddescription);

          setProductSize(sizeval);
        //  setSize(productSize[0]);
       }
      })
      .catch((error) => {
        error;
      });
  }, []);

  useEffect(() => {
    fetchAllDataGet_byApiName('GetMasterProductDetails', apiUriMasterDataHttp())
      .then((response) => {
        if (productType.length !== 0) {
          const filteredItems = response.filter((item) => item.producttype === productType);
          const sizeval = filteredItems.map((item) => item.productdescription);
          setProductSize(sizeval);
         // setSize(productSize[0])
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [productType]);
  console.log(productSize[0]);
  useEffect(()=>{  setSize(productSize[0]);
  },productSize)
  //useEffect(()=)

  useEffect(() => {
    if (size && productType) {
      prodDetail
        .filter((item) => item.producttype === productType && item.productdescription === size)
        .forEach((item) => {
          console.log(item.productcode);
          setProdCode(item.productcode);
        });
    }
  }, [size, productType]);

  useEffect(() => {
    if (prodCode !== undefined) {
      const jsonToSend = {
        productcode: prodCode,
        plannedyears: plannedYears,
      };
      sendAllDataPost_byApiNameAndData('GetConsumablesEstimation', jsonToSend, apiUriConsumableDataHttp())
        .then((dataFromApi) => {
          setdataForColumns(dataFromApi);
        })
        .catch((error) => {
          console.log('Failed to Fetch users');
        });
      // setMakeJson(jsonToSend)

      console.log(jsonToSend);
    } else {
      console.log('no data');
    }
  }, [prodCode, plannedYears]);

  const handleProductTypeChange = (value) => {
    setProducttype(value);
  };
  const handleProductSizeChange = (value) => {
    setSize(value);
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleSubmit = () => {
    setPlannedYears(inputValue);
  };
  console.log(dataForColumns);
  const displayDataForColumns = useMemo<consumableEstimationType[]>(() => {
    let formattedData: consumableEstimationType[] = [];
    if (dataForColumns) {
      formattedData = dataForColumns?.map((apiData: consumableEstimationType) => ({
        displayseq: apiData.displayseq,
        areacode: apiData.areacode,
        zonecode: apiData.zonecode,
        equipmentcode: apiData.equipmentcode,
        positionnumber: apiData.positionnumber,
        consumablecode: apiData.consumablecode,
        drawingnumber: apiData.drawingnumber,
        quantityinstalled: apiData.quantityinstalled,
        quantityredressed: apiData.quantityredressed,
        lifetime: apiData.lifetime,
        totallifetime: apiData.totallifetime,
        yearlyproduction: apiData.yearlyproduction,
        estimatedquantity: apiData.estimatedquantity,
      }));
    }
    return formattedData;
  }, [dataForColumns]);
  return {
    t,
    columnNames,
    displayDataForColumns,
    inputValue,
    setInputValue,
    handleInputChange,
    handleSubmit,
    dataForColumns,
    productType,
    handleProductTypeChange,
    productTypesList,
    productSize,
    handleProductSizeChange,
    size,
  };
}

export default useConsumableQuantityEstimationHook;
